const templateJSONDefault = {
  counters: {
    u_column: 1,
    u_row: 1,
    u_content_html: 1,
  },
  body: {
    id: 'fQYxbXlgzk',
    rows: [{
      id: 'hmbz6BXOiO',
      cells: [1],
      columns: [{
        id: 'aKInXYZKP6',
        contents: [{
          id: 'B32XsDzyct',
          type: 'html',
          values: {
            html: `<table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
  <tbody>
    <tr>
      <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
        <div>
          <table role="presentation" border="0" cellpadding="0" cellspacing="0">
            <tr>
              <td style="border-bottom: 2px solid #9b095d">
                <h3 style="line-height: 30px; text-align: center">
                  APRESENTAÇÃO VIKTECH
                </h3>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 20px">
                <h3 style="text-align: left; margin-bottom: 10px;">Olá!</h3>
                <p style="text-align: justify; margin-bottom: 15px; font-size: 14px;">
                  Escrevo para apresentar a <strong>VIKTECH</strong> (<a href="https://www.viktech.com.br" style="color: #9b095d;">www.viktech.com.br</a>), empresa de TECNOLOGIA e BPO (Terceirização de Mão de Obra e Atividades Completas) com atuação 100% customizada à necessidade de cada cliente.
                  Temos clientes como <strong>VALE, BANCO SAFRA, FGV, TECBAN, ENEL, VTAL, EDP</strong>...
                </p>
                <p style="font-weight: bold; margin-bottom: 5px; color: #333333; font-size: 14px;">
                  Podemos resumir nossa atuação nas 2 Frentes a seguir:
                </p>
                <!-- FRENTE 1: BPO/TERCEIRIZAÇÃO -->
                <h4 style="text-align: left; margin-bottom: 5px; color: #000000; font-weight: bold; font-size: 14px;">
                  BPO / TERCEIRIZAÇÃO:
                </h4>
                <ul style="margin: 0; padding-left: 25px; text-align: justify; margin-bottom: 15px; font-size: 13px; line-height: 1.5;">
                  <li>SAC (Serviço Atendimento ao Cliente), Backoffices em Geral;</li>
                  <li>Terceirização de Mão de Obra dos mais variados Skills possíveis;</li>
                  <li>Terceirização de todo o Processo de Recrutamento e Seleção de sua empresa.</li>
                </ul>
                <!-- FRENTE 2: TECNOLOGIA -->
                <h4 style="text-align: left; margin-bottom: 5px; color: #000000; font-weight: bold; font-size: 14px;">
                  TECNOLOGIA:
                </h4>
                <ul style="margin: 0; padding-left: 25px; text-align: justify; margin-bottom: 20px; font-size: 13px; line-height: 1.5;">
                  <li>Terceirização de Mão de Obra de Tecnologia (Devs, POs, Manutenção de Equipamentos TI...);</li>
                  <li>Desenvolvimento de Sistemas Completos e Plataforma de Atendimento por Multicanais com IA embarcada (Whatsapp, E-mail...).</li>
                </ul>
                <p style="text-align: justify; margin-bottom: 10px; font-size: 14px;">
                  Visite nosso site (<a href="https://www.viktech.com.br" style="color: #9b095d;">www.viktech.com.br</a>) para nos conhecer melhor. Caso deseje, estamos à disposição para um bate-papo rápido onde apresentaremos nossas soluções.
                </p>
                <p style="text-align: left; margin-bottom: 5px; margin-top: 15px; font-weight: bold;">Att,</p>
                <!-- Assinatura -->
                <h4 style="text-align: left; margin-top: 0px; margin-bottom: 5px; font-size: 14px;">
                </h4>
                <h4 style="text-align: left; margin-top: 0px; font-size: 13px; color: #555555;">
                </h4>
                <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                  <tr>
                    <td style="width: 100px; text-align: top">
                      <img src="https://vikdocumentdb.blob.core.windows.net/utils/logo-vik.png?sv=2021-10-04&st=2022-12-28T16%3A09%3A43Z&se=2030-12-29T16%3A09%3A00Z&sr=b&sp=r&sig=mVvseQZKzC%2Fgn29112zosH7dbWoPgh6YXpqUrl3tPWo%3D" alt="VIK Tech" width="90" height="90" />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </td>
    </tr>
  </tbody>
</table>`,
            displayCondition: null,
            containerPadding: '10px',
            anchor: '',
            _meta: {
              htmlID: 'u_content_html_1',
              htmlClassNames: 'u_content_html',
            },
            selectable: true,
            draggable: true,
            duplicatable: true,
            deletable: true,
            hideable: true,
          },
        }],
        values: {
          backgroundColor: '',
          padding: '0px',
          border: {},
          _meta: {
            htmlID: 'u_column_1',
            htmlClassNames: 'u_column',
          },
        },
      }],
      values: {
        displayCondition: null,
        columns: false,
        backgroundColor: '',
        columnsBackgroundColor: '',
        backgroundImage: {
          url: '',
          fullWidth: true,
          repeat: 'no-repeat',
          size: 'custom',
          position: 'center',
        },
        padding: '0px',
        anchor: '',
        hideDesktop: false,
        _meta: {
          htmlID: 'u_row_1',
          htmlClassNames: 'u_row',
        },
        selectable: true,
        draggable: true,
        duplicatable: true,
        deletable: true,
        hideable: true,
      },
    }],
    headers: [],
    footers: [],
    values: {
      popupPosition: 'center',
      popupWidth: '600px',
      popupHeight: 'auto',
      borderRadius: '10px',
      contentAlign: 'center',
      contentVerticalAlign: 'center',
      contentWidth: '500px',
      fontFamily: {
        label: 'Arial',
        value: 'arial,helvetica,sans-serif',
      },
      textColor: '#000000',
      popupBackgroundColor: '#FFFFFF',
      popupBackgroundImage: {
        url: '',
        fullWidth: true,
        repeat: 'no-repeat',
        size: 'cover',
        position: 'center',
      },
      popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
      popupCloseButton_position: 'top-right',
      popupCloseButton_backgroundColor: '#ffffff',
      popupCloseButton_iconColor: '#000000',
      popupCloseButton_borderRadius: '0px',
      popupCloseButton_margin: '0px',
      popupCloseButton_action: {
        name: 'close_popup',
        attrs: {
          onClick: "document.querySelector('.u-popup-container').style.display = 'none';",
        },
      },
      backgroundColor: '#e7e7e7',
      backgroundImage: {
        url: '',
        fullWidth: true,
        repeat: 'no-repeat',
        size: 'custom',
        position: 'center',
      },
      preheaderText: '',
      linkStyle: {
        body: true,
        linkColor: '#0000ee',
        linkHoverColor: '#0000ee',
        linkUnderline: true,
        linkHoverUnderline: true,
      },
      _meta: {
        htmlID: 'u_body',
        htmlClassNames: 'u_body',
      },
    },
  },
  schemaVersion: 16,
}

export default templateJSONDefault
